"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTheme = exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _fgLoadcss = require("fg-loadcss");

var _material = require("@mui/material");

var _AdapterMoment = _interopRequireDefault(require("@mui/lab/AdapterMoment"));

var _LocalizationProvider = _interopRequireDefault(require("@mui/lab/LocalizationProvider"));

var _theme = require("../../theme");

var _overrides = _interopRequireDefault(require("./overrides"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isTesting = process.env.NODE_ENV === "test";
var defaultTheme = (0, _material.createTheme)(_objectSpread(_objectSpread({
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#fff",
          color: _theme.palette.brand.grey.pebble
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        colorDefault: {
          backgroundColor: _theme.palette.primary.main
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disableFocusRipple: true,
        variant: "contained"
      },
      styleOverrides: _objectSpread({}, _overrides.default.MuiButton)
    },
    MuiCard: {
      defaultProps: {
        elevation: 2
      },
      styleOverrides: _objectSpread({}, _overrides.default.MuiCard)
    },
    MuiCardActions: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiCardActions)
    },
    MuiCardContent: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiCardContent)
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          variant: "h2"
        }
      },
      styleOverrides: _objectSpread({}, _overrides.default.MuiCardHeader)
    },
    MuiChip: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiChip)
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorSecondary: {
          color: "white"
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem"
        }
      }
    },
    MuiFab: {
      defaultProps: {
        disableFocusRipple: true
      }
    },
    MuiFormControl: {
      defaultProps: {
        variant: "standard"
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "0.75rem"
        },
        root: {
          "&:last-child": {
            paddingBottom: 0
          },
          marginLeft: "-".concat(_theme.spacing[2]),
          // -11px by default, don't need quite that much
          paddingBottom: _theme.spacing[2]
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: _theme.palette.brand.grey.grey
          },
          "&.Mui-error": {
            color: _theme.palette.error.main
          },
          color: _theme.palette.brand.grey.grey
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: _theme.palette.brand.red
        },
        root: {
          "&.Mui-disabled": {
            color: _theme.palette.brand.grey.charcoal
          },
          "&.Mui-focused, &.Mui-error": {
            color: _theme.palette.brand.grey.charcoal
          },
          color: _theme.palette.brand.grey.charcoal,
          fontSize: "0.75rem",
          fontWeight: "bold"
        }
      }
    },
    MuiIcon: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiIcon)
    },
    MuiIconButton: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiIconButton)
    },
    MuiInput: {
      styleOverrides: {
        formControl: {
          borderRadius: "1px",
          "label + &": {
            marginTop: _theme.spacing[2]
          }
        },
        underline: {
          "&:before, &:after, &:hover:not(.Mui-disabled):before": {
            borderBottom: "none"
          }
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: "inherit"
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        adornedEnd: {
          backgroundColor: "white"
        },
        adornedStart: {
          backgroundColor: "white"
        },
        input: {
          padding: "0.4rem ".concat(_theme.spacing[2], " 0.4rem ").concat(_theme.spacing[2])
        },
        inputSizeSmall: {
          paddingTop: _theme.spacing[2] // Overwride default of 3px

        },
        multiline: {
          paddingLeft: _theme.spacing[2],
          paddingRight: _theme.spacing[2]
        },
        root: {
          "&.Mui-disabled": {
            "&.Mui-error": {
              color: _theme.palette.error.main
            },
            "&.MuiInput-underline.Mui-disabled:before": {
              borderBottomStyle: "none"
            },
            backgroundColor: _theme.palette.brand.grey.lightGrey,
            color: _theme.palette.brand.grey.grey
          },
          "&.Mui-error": {
            "&:hover, &.Mui-focused": {
              borderColor: _theme.palette.error.main
            },
            borderColor: _theme.palette.error.main,
            color: _theme.palette.error.main
          },
          "&.Mui-focused": {
            borderColor: _theme.palette.brand.grey.charcoal
          },
          "&:hover": {
            borderColor: _theme.palette.primary.main
          },
          background: "white",
          border: "1px solid ".concat(_theme.palette.brand.grey.stone),
          fontSize: "0.75rem"
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        formControl: {
          lineHeight: "1.50",
          position: "unset"
        },
        outlined: {
          "&.Mui-focused": {
            color: _theme.palette.brand.grey.charcoal
          }
        },
        root: {
          whiteSpace: "normal",
          wordBreak: "break-word"
        },
        shrink: {
          transform: "translate(0,1.5px)"
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiLinearProgress)
    },
    MuiLink: {
      defaultProps: {
        underline: "hover"
      }
    },
    MuiList: {
      styleOverrides: {
        padding: {
          paddingBottom: 0,
          paddingTop: 0
        }
      }
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          color: _theme.palette.brand.grey.charcoal,
          fontSize: "0.75rem",
          fontWeight: "bold",
          lineHeight: 3
        },
        sticky: {
          backgroundColor: "white"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiMenuItem)
    },
    MuiOutlinedInput: {
      styleOverrides: {
        adornedEnd: {
          paddingRight: 0
        },
        adornedStart: {
          paddingLeft: 0
        },
        root: {
          "&:focused $notchedOutline": {
            borderColor: _theme.palette.brand.grey.charcoal,
            borderWidth: 1
          },
          "&:hover $notchedOutline": {
            borderColor: _theme.palette.primary.main
          }
        }
      }
    },
    // @ts-ignore: It looks like the types haven't been moved for date pickers.
    MuiPickersCalendar: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiPickersCalendar)
    },
    MuiPickersDay: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiPickersDay)
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          minWidth: "12rem"
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        colorPrimary: {
          "&.Mui-disabled.Mui-checked": {
            color: _theme.palette.primary.main,
            opacity: 0.26
          }
        },
        root: {
          "&:hover, &:focus-within": {
            backgroundColor: _theme.palette.primary.light
          },
          border: "1px solid transparent",
          borderRadius: "50%",
          padding: 0,
          paddingRight: _theme.spacing[1]
        }
      }
    },
    MuiTab: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true
      },
      styleOverrides: {
        root: {
          "&:hover, &:focus": {
            color: _theme.palette.primary.main
          },
          fontSize: "0.875rem",
          paddingLeft: 0,
          paddingRight: 0,
          textTransform: "none"
        },
        textColorPrimary: {
          color: _theme.palette.brand.grey.charcoal
        }
      }
    },
    MuiTableCell: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiTableCell)
    },
    MuiTableContainer: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiTableContainer)
    },
    MuiTableHead: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiTableHead)
    },
    MuiTableRow: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiTableRow)
    },
    MuiTableSortLabel: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiTableSortLabel)
    },
    MuiTextField: {
      defaultProps: {
        InputLabelProps: {
          shrink: true
        },
        variant: "standard"
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          overflow: "auto"
        }
      }
    },
    MuiTypography: {
      styleOverrides: _objectSpread({}, _overrides.default.MuiTypography),
      variants: [{
        props: {
          color: "primary"
        },
        style: {
          color: _theme.palette.brand.grey.charcoal
        }
      }, {
        props: {
          color: "secondary"
        },
        style: {
          color: _theme.palette.brand.grey.grey
        }
      }, {
        props: {
          color: "textTertiary"
        },
        style: {
          color: _theme.palette.brand.grey.stone
        }
      }, {
        props: {
          variant: "body3"
        },
        style: {
          fontSize: "0.75rem"
        }
      }, {
        props: {
          variant: "chip"
        },
        style: {
          fontSize: "0.875rem",
          fontWeight: "bold"
        }
      }]
    }
  },
  mixins: {
    toolbar: {
      minHeight: 48 // This removes the other media breakpoints which causes shorter Toolbars on smaller devices

    }
  },
  palette: _theme.palette,
  spacing: _theme.spacing
}, isTesting ? {
  transitions: {
    create: function create() {
      return "none";
    }
  }
} : {}), {}, {
  typography: {
    fontFamily: ["Arial", "sans-serif"].join(",")
  },
  widths: {
    sideNav: 245
  }
}));
exports.defaultTheme = defaultTheme;

var _default = function _default(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  (0, _react.useEffect)(function () {
    var _ref2;

    (0, _fgLoadcss.loadCSS)("https://use.fontawesome.com/releases/v5.15.4/css/all.css", (_ref2 = document.querySelector("#font-awesome-css")) !== null && _ref2 !== void 0 ? _ref2 : undefined, undefined, {
      crossorigin: "anonymous",
      integrity: "sha384-DyZ88mC6Up2uqS4h/KRgHuoeGwBcD4Ng9SiP4dIRy0EXTlnuz47vAwmeGwVChigm"
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ThemeProvider, _objectSpread(_objectSpread({
    theme: defaultTheme
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LocalizationProvider.default, {
      dateAdapter: _AdapterMoment.default,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CssBaseline, {}), children]
    })
  }));
};

exports.default = _default;